<template>
    <div>
        <member-write-link v-for="component in optionLayouts" :key="`memberComp${component}`" :writeLayout="component"
                           :memberData="memberData"  :memberFlyhighData="memberFlyhighData" :setData="setData"></member-write-link>
    </div>
</template>

<script>
import VuxAlert from '@/mixins/vux-alert';
import memberUtil from "@/components/member/memberUtil";
import MemberWriteLink from "@/components/member/MemberWriteLink";
import MemberValidator from "@/mixins/validators/MemberValidator"
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

export default {
    name: 'MemberWriteComponent',
    components: {
        MemberWriteLink
    },
    mixins: [VuxAlert, memberUtil, MemberValidator],
    props: {
        memberType: {
            type: String,
            default: '',
        },
        memberKey: {
            default: null,
        },
    },
    data() {
        return {
            optionLayouts: [],
            createApiParamSet: {},
            detailApiParamSet: {},
            directUrl: '',
            resultAlertTxt: '',
            validateAlertText: '',
            parsingData: {},
            memberData: {},
            memberFlyhighData: {},
        }
    },
    mounted() {
        EventBus.$on('writeMember', this.writeMember);
        EventBus.$on('writeFlyhighMember', this.writeFlyhighMember);
        EventBus.$on('quitMember', this.quitMemberConfirm);
    },
    watch: {},
    created() {
        this.initConfig();
    },
    beforeDestroy() {
        EventBus.$off('writeMember');
        EventBus.$off('writeFlyhighMember');
        EventBus.$off('quitMember');
    },
    methods: {
        initConfig() {
            let memberConfig = this.returnMemberConfig(this.memberType)
            this.createApiParamSet = memberConfig.createApiParamSet;
            this.detailApiParamSet = memberConfig.detailApiParamSet;
            this.directUrl = memberConfig.directUrl;
            this.resultAlertTxt = memberConfig.resultAlertTxt;
            this.validateAlertText = memberConfig.validateAlertText;
            this.parsingData = memberConfig.parsingData;
            if (this.memberKey != null) {
                this.getMember();
            } else {
                this.initTemplate();
            }
        },
        initTemplate() {
            let memberConfig = this.returnMemberConfig(this.memberType)
            this.optionLayouts = memberConfig.optionLayouts;
        },
        setData(key, value) {
            this[key] = value;
        },
        getInfo() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
            params.no = this.memberKey;
            this.no = this.memberKey;
            try {
                this.$api.$member.getFlyhighMember(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type != 1) {
                        this.createAlert({
                            title: '알림',
                            content: '회원정보를 불러올 수 없습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.back();
                            }
                        })
                    }
                    let info = res.List[0];
                    this.id = info.mb_id;
                    this.type = info.social_type;
                    this.nick = info.mb_nick;
                    this.memo = info.mb_memo;
                    this.memberFlyhighData = {
                        id: this.id,
                        type: this.type,
                        nick: this.nick,
                        memo: this.memo,
                    }
                    this.initTemplate();
                });
            } catch (e) {
                console.log(e);
            }
        },
        getMember() {
            let params = {
                mb_no: this.memberKey
            };

            this.$api.$member.getMember(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 || res.List.length === 0) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.memberData = res.List;
                this.getInfo();
            })
        },
        writeMember() {
            let dataKeys = [];
            if (!util.isEmpty(this.password) || !util.isEmpty(this.password_chk)) {
                dataKeys.push('password');
                dataKeys.push('password_chk');
            }
            if(!util.isEmpty(this.phone) ||!util.isEmpty(this.phoneValue) ){
                dataKeys.push('phone');
                dataKeys.push('phoneValue');
            }
            this.$validate(dataKeys).then((success) => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.');
                    return false;
                }
            })
            if (this.memberData.mb_hp !== `${this.phoneValue}-${this.phone}`) {
                this.checkPhone();
            } else {
                this.setPassword();
            }
        },
        writeFlyhighMember() {
            let validateArr = Object.keys(this.parsingData);

            this.$validate(validateArr).then((success) => {
                if (!success) {
                    this.errorAlert(this.validateAlertText);
                    return false;
                }
                let params = JSON.parse(JSON.stringify(this.createApiParamSet));
                let dataKeys = Object.keys(this.parsingData);
                dataKeys.forEach(dataKey => {
                    params[this.parsingData[dataKey]] = this[dataKey];
                });
                if (params.mb_nick === this.memberFlyhighData.nick) {
                    delete params.mb_nick;
                }
                try {
                    this.$api.$member.updateMember(params).then(res => res.Data.Result).then(res => {
                        let type = this.writeReturnType(res.Info.type);
                        if (type != true) {
                            this.errorAlert(type);
                            return false;
                        } else {
                            this.updateMemberAfterFunc();
                        }
                    })
                } catch (e) {
                    console.log(e);
                }
            })
        },
        checkPhone() {
            this.$validate(['phoneValue', 'phone']).then(res => {
                if (res) {
                    let params = {
                        mb_hp: `${this.phoneValue}-${this.phone}`,
                    }
                    this.$api.$member.checkPhone(params).then(res => res.Data.Result).then(res => {
                        if (res.Info.type !== 1) {
                            this.errorAlert('전화번호가 중복됩니다.');
                        } else {
                            this.updatePhone();
                        }
                    })
                }
            })
        },
        updatePhone() {
            let params = {
                mb_hp: `${this.phoneValue}-${this.phone}`,
                mb_no: this.memberKey
            }
            this.$api.$member.updatePhone(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type !== 1) {
                    this.errorAlert('전화번호 변경에 실패하였습니다.');
                } else {
                    this.setPassword();
                }
            })
        },
        setPassword() {
            if (!util.isEmpty(this.password) && !util.isEmpty(this.password_chk)) {
                this.$validate(['password', 'password_chk']).then(res => {
                    if (res) {
                        let params = {
                            mb_no: this.memberKey,
                            mb_password: this.password,
                            mb_password_confirmation: this.password_chk
                        }
                        this.$api.$member.updateMemberPwd(params).then(res => res.Data.Result).then(res => {
                            if (res.Info.type !== 1) {
                                this.errorAlert('저장에 실패하였습니다.');
                            } else {
                                this.updateMemberAfterFunc()
                            }
                        })
                    }
                })
            }else{
                this.updateMemberAfterFunc()
            }
        },
        updateMemberAfterFunc() {
            this.createAlert({
                title: '확인',
                content: this.resultAlertTxt,
                btnText: '확인',
                hide: () => {
                    if (this.directUrl === '') {
                        EventBus.$emit('removePassword');
                        this.password = '';
                        this.password_chk = '';
                        this.getInfo();
                        return false;
                    }
                    if (this.directUrl === 'back') {
                        this.$router.back();
                        return false;
                    }
                    let url = this.directUrl;
                    if (this.directType === 'detail') {
                        url = url + res.List;
                    }
                    this.$router.push(url);
                }
            })
        },
        writeReturnType(type) {
            let typeNum = Number(type);
            switch (typeNum) {
                case 1:
                    return true;
                case -221:
                    return '닉네임이 중복되었습니다.';
                default:
                    return '회원수정에 실패하였습니다. 잠시 다시 시도해 주세요.';
            }
        },
        quitMemberConfirm() {
            this.createConfirm({
                title: '알림',
                content: '정말 강제탈퇴처리하시겠습니까?',
                confirmText: '확인',
                cancelText: '취소',
                confirm: () => {
                    this.quitMember();
                }
            })
        },
        quitMember() {
            let params = {
                m_type: 'normal',
                mb_no: this.memberKey,
                moc_idx: [5],
            }
            try {
                this.$api.$member.quitMember(params).then(res => res.Data.Result).then(res => {
                    let type = this.quitReturnType(res.Info.type);
                    if (type != true) {
                        this.errorAlert(type);
                        return false;
                    }
                    this.createAlert({
                        title: '확인',
                        content: '회원탈퇴가 완료되었습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    })
                })
            } catch (e) {
                console.log(e);
            }
        },
        quitReturnType(type) {
            let typeNum = Number(type);
            switch (typeNum) {
                case 1:
                    return true;
                    ;
                case -400:
                    return '해당 회원은 탈퇴가 불가능합니다.';
                case -404:
                    return '이미 탈퇴된 회원입니다.';
                default:
                    return '강제 탈퇴에 실패하였습니다. 잠시 다시 시도해 주세요.';
            }
        },
    }
}
</script>
